<template>
  <div class="animated fadeIn">
   
    <b-alert show dismissible >
      <b>Please note:</b> This Roadmap page is update regularly.
    </b-alert>

    <b-card>
      <b-card-body >
        <h1>
          Roadmap of 
          <br />
          Cashbac UI
        </h1>
        <h4>
          All the planning under one roof.
        </h4>
        <hr class="my-4">
        <p>
          Interested in what’s planned for Cashbac Web UI Kit in the coming weeks and months?
          <br />
          This is a good place to start. Roadmap contains delivery estimates only in quarter scope. 
          <br />
          For a more detailed overview of what is already designed and in what state, visit component status.
        </p>
      </b-card-body>
    </b-card>
  <!-- HERO END -->

    <b-card>
      <b-card-body>
          <h1>Roadmaps</h1>
          <b-tabs>
            <b-tab active>
              <template slot="title">
                🚀 Current quarter (Q4 of 2019)
              </template>
              <br>
              <p>
              - Implement end-to-end tests for better coverage on cashbac-components <br />
              - Create library for Illustrations <br />
              - Add Cashbac Brand Guidelines
              <br />
              - Add Changelog and component status page
              </p>
            </b-tab>
            <b-tab>
              <template slot="title">
                🏗 Next quarter or two (Q1 or Q2 of 2020)
              </template>
              <br>
              <p>
              - Creating dark theme palette<br />
              - Create library for landing pages cashbac[dot]com
              </p>
            </b-tab>
            <b-tab>
              <template slot="title">
                🔮 Future
              </template>
              <br>
              <p>
              - Add Design Token
              <br />
              - Make open source this Cashbac Web UI Kit <br />
              - Add Foundation: Voice and Tones 
              </p>
            </b-tab>
          </b-tabs>

        
        
      </b-card-body>
    </b-card>
    <b-card>
      <b-card-body>
        <div>
          <h1>Changelog</h1>
          <p>
            
              <b-badge class="m-1" pill variant="success">0.1.0</b-badge> Setup Repo & Web Docs <br />
              <b-badge class="m-1" pill variant="success">0.1.1</b-badge> Added Foundation: Colors <br />
              <b-badge class="m-1" pill variant="success">0.1.2</b-badge> Added Foundation: Typography <br />
              <b-badge class="m-1" pill variant="success">0.1.3</b-badge> Added Foundation: Spacing <br />
              <b-badge class="m-1" pill variant="success">0.1.4</b-badge> Added Foundation: Icon <br />
              <b-badge class="m-1" pill variant="success">0.1.5</b-badge> Button <br />
              <b-badge class="m-1" pill variant="success">0.1.6</b-badge> Form <br />
              <br />
              <b-badge class="m-1" pill variant="success">0.2.0</b-badge> Table <br />
              <b-badge class="m-1" pill variant="success">0.2.1</b-badge> Widget <br />
              <b-badge class="m-1" pill variant="success">0.2.2</b-badge> Date Picker <br />
              <b-badge class="m-1" pill variant="success">0.2.3</b-badge> Chart <br />
              <b-badge class="m-1" pill variant="success">0.2.4</b-badge> Progress Bar <br />
              <br />
              <b-badge class="m-1" pill variant="success">0.3.0</b-badge> Modal <br />
              <b-badge class="m-1" pill variant="success">0.3.1</b-badge> Alert & Toast <br />
              <b-badge class="m-1" pill variant="success">0.3.2</b-badge> Tooltips, Popovers <br />
              <b-badge class="m-1" pill variant="success">0.3.3</b-badge> Drawer <br />
              <br />
              <b-badge class="m-1" pill variant="success">0.4.0</b-badge> Layout <br />
              <b-badge class="m-1" pill variant="success">0.4.1</b-badge> Header <br />
              <b-badge class="m-1" pill variant="success">0.4.2</b-badge> Sidebar <br />
              <b-badge class="m-1" pill variant="success">0.4.3</b-badge> Navbar <br />
              <b-badge class="m-1" pill variant="success">0.4.4</b-badge> Tabs <br />
              <b-badge class="m-1" pill variant="success">0.4.5</b-badge> Brand <br />
              <b-badge class="m-1" pill variant="success">0.4.6</b-badge> Illustration <br />
              <b-badge class="m-1" pill variant="success">0.4.7</b-badge> Added Page Sample <br />

          </p>

  
        </div>
        
        
      </b-card-body>
    </b-card>
    
  </div>
</template>

<script>
export default {
  name: 'roadmap'
}
</script>
